const localStatisticsActions = {
  ADD_TO_BAG_ERROR: 'add_to_bag_error',
  ADD_TO_LIST_ERROR: 'add_to_list_error',
  ADD_UNAVAILABLE_TO_CART: 'add_unavailable_to_cart',
  ADD_UNAVAILABLE_TO_CART_AND_LIST: 'add_unavailable_to_cart_and_list',
  TAC_ARTICLE_CLICKED: 'tac_article_clicked',
  CONF_MENU_SLIDER: 'conf_menu_slider',
  CONF_MENU_INFO_BUTTON_CLICKED: 'conf_menu_info_button_clicked',
  PRODUCT_MENU_MOUNTING_RAIL_INFO_CLICKED:
    'product_menu_mounting_rail_info_clicked',
  NO_SAVE: 'no_save',
  SAVE: 'save',
  PRODUCT_MENU_SWIPER_INTERACTION: 'product_menu_swiper_interaction',
  PRODUCT_MENU_SUB_FILTER_INTERACTION: 'product_menu_sub_filter_interaction',
  VALIDATION_ERROR: 'validation_error',
  OPEN_PLANNER: 'open_planner',
  START_VIEW_SPR_CLICKED: 'start_view_spr_clicked',
  START_VIEW_VPC_ENTER_CODE_SUCCESS: 'start_view_vpc_enter_code_success',
  SPR_DEEPLINK: 'open_planner_spr_deeplink',
  OPEN_PLANNER_SPR_DEEPLINK_NOT_SUPPORTED:
    'open_planner_spr_deeplink_not_supported',
  OPEN_PLANNER_VPC_DEEPLINK_NOT_SUPPORTED:
    'open_planner_vpc_deeplink_not_supported',
  VPC_DEEPLINK: 'open_planner_vpc_deeplink',
  NOT_LOADED: 'not_loaded',
  SURVEY_FEEDBACK: 'submit_survey_feedback',
  SHOW_SURVEY: 'show_survey',
  TERMINATE_SURVEY: 'terminate_survey',
  SUB_PLANNER_USER_CHOICE: 'sub_planner_user_choice',
  SUB_PLANNER_AUTOMATIC_CHOICE: 'sub_planner_automatic_choice',
  LANGUAGE_SELECTOR_USER_CHOICE: 'language_selector_user_choice',
  SERIES_GALLERY_USAGE: 'series_gallery_usage',
  AMELIORATION_DIALOG_SHOWN: 'amelioration_dialog_shown',
  AMELIORATION_DIALOG_ACCEPTED: 'amelioration_dialog_accepted',
  AMELIORATION_DIALOG_DECLINED: 'amelioration_dialog_declined',
  AMELIORATION_ATTEMPT: 'amelioration_attempt',
  AMELIORATION_CAN_NOT_BE_SOLVED: 'amelioration_can_not_be_solved',
  AMELIORATION_SOLVED: 'amelioration_solved',
  AMELIORATION_DECLINED: 'amelioration_declined',
};

export default localStatisticsActions;
